import React from 'react'
import PropTypes from "prop-types"

const BlankLayout = ({children, containerClass}) => {
    return (
        <>
            <div className="grid relative" style={{  gridArea: "1/1" }}>
                <div className={containerClass ?? "container mx-auto py-8 px-2 bg-white"}>
                {children}
                </div>
          </div>
        </>
    )
}

BlankLayout.propTypes = {
    children: PropTypes.node.isRequired,
}
export default BlankLayout
